import { useQuery } from '@tanstack/react-query';

import bundlesService from '~/services/cruises/BundlesService';

import { bundleQueryKeys } from './bundleQueryKeys';

export function useGetBundleFilters(bundleId: string) {
  return useQuery({
    queryKey: bundleQueryKeys.filters(bundleId),
    queryFn: async () => {
      const response = await bundlesService.getFilters(bundleId);
      return response.result;
    },
    enabled: !!bundleId,
  });
}
